import {Component} from '@angular/core';

import {HomePage} from "../home/home";
import {BookingsPage} from "../bookings/bookings";
import {TrendingCutsPage} from "../trending-cuts/trending-cuts";
import {App, Events} from "ionic-angular";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {ProfileLoginPage} from "../profile-login/profile-login";
import {MyChairPage} from "../my-chair/my-chair";
import {MyChairMultipleShopPage} from "../my-chair-multiple-shop/my-chair-multiple-shop";
import {TeamServiceProvider} from "../../providers/team-service/team-service";
import {SearchPage} from "../search/search";
import {ShopListingPage} from "../shop-listing/shop-listing";
import {ShopPage} from "../shop/shop";
import { CoffeShopPage } from '../coffe-shop/coffe-shop';
import { MyNewChairPage } from '../my-new-chair/my-new-chair';
import { MessengerPage } from '../messenger/messenger';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  errors: {};
  loading: boolean;
  tuid: string;
  teamId: string;
  accountType: number;
  isStaff: boolean;
  totalUpcomingBookings: number;
  totalStaffBookings: number;
  hasMultiShops: boolean;

  tab1Root: any;
  tab2Root: any;
  tab3Root: any;
  tab4Root: any;
  tab5Root: any;
  tab6Root: any;
  tab7Root: any;
  search:any = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M13.4167 24.5C19.5378 24.5 24.5 19.5378 24.5 13.4167C24.5 7.29551 19.5378 2.33334 13.4167 2.33334C7.29552 2.33334 2.33334 7.29551 2.33334 13.4167C2.33334 19.5378 7.29552 24.5 13.4167 24.5Z" fill="#595A5B"/>
<path d="M24.85 25.6667C24.64 25.6667 24.43 25.585 24.2783 25.4333L22.1083 23.2633C21.7933 22.9483 21.7933 22.435 22.1083 22.1083C22.4233 21.7933 22.9367 21.7933 23.2633 22.1083L25.4333 24.2783C25.7483 24.5933 25.7483 25.1067 25.4333 25.4333C25.27 25.585 25.06 25.6667 24.85 25.6667Z" fill="#595A5B"/>
</svg>`

  constructor(
    public events: Events,
    private http: HttpClient,
    private teamProvider: TeamServiceProvider,
    private apiErrorHandler: ApiErrorHandlerProvider,
    public app: App
  ) {
    this.tab1Root = '';
    this.tab2Root = BookingsPage;
    this.tab3Root = TrendingCutsPage;
    this.tab4Root = MyChairPage;    
    // this.tab4Root = MyNewChairPage;
    this.tab5Root = MyChairMultipleShopPage;
    this.tab6Root = ProfileLoginPage;
    this.tab7Root = MessengerPage;

    this.tuid = localStorage.getItem('tuid');
    this.accountType = localStorage.getItem('accountType') ? parseInt(localStorage.getItem('accountType')) : null;
    this.totalUpcomingBookings = 0;
    this.totalStaffBookings = 0;
    this.isStaff = this.accountType && (this.accountType === 1 || this.accountType === 3);
    this.teamId = localStorage.getItem('currentTeamId');
    this.hasMultiShops = false;

    events.subscribe('booking:badge', (bookings) => {
      this.updateBookingsCount(bookings);
    });

    events.subscribe('booking:badge+', () => {
      this.totalUpcomingBookings += 1;
    });

    events.subscribe('booking:badge-', () => {
      this.totalUpcomingBookings -= 1;
    });

    events.subscribe('user:login', () => {
      this.tuid = localStorage.getItem('tuid');
      this.teamId = localStorage.getItem('currentTeamId');

      this.getBookings().then((bookings) => {
        this.updateBookingsCount(bookings);
      });

      this.accountType = parseInt(localStorage.getItem('accountType'));
      if (this.accountType && (this.accountType === 1 || this.accountType === 3)) {
        this.isStaff = true;
      }
      this.toggleMyChairTabElement();
      this.setStaffTabBookingsCount();
    });

    events.subscribe('user:logout', () => {
      this.accountType = null;
      this.isStaff = false;
      this.totalUpcomingBookings = null;
      this.totalStaffBookings = null;
      localStorage.removeItem('stripeCustomerId');
      this.toggleMyChairTabElement();
    });

    events.subscribe('myChair:badge', () => {
      if (this.isStaff) {
        this.getBookingsCountForStaff().then((count: number) => {
          this.totalStaffBookings = count;
        });
      }
    });

    this.setStaffTabBookingsCount();

    if (this.teamProvider.isCustomApp()) {
      this.tab1Root = HomePage;
    } else {
      this.tab1Root = SearchPage;
    }

    // For the web version of the app we will listen for /#/teams/47
    // If found then we will push the user to the shop view straight away
    let shop = this.getTeamIdFromURL();
    if (shop.id){
      if (shop.hasLocations) {
        this.tab1Root = ShopListingPage;
        localStorage.setItem('webShopId', shop.id);
      } else {
        this.detectShopType(shop.id);
        localStorage.setItem('webShopId', shop.id);
      }
      return;
    }
  }

  getTeamIdFromURL(){
    let shop = {
      id: null,
      hasLocations: false
    };

    let url = window.location.hash.toString();

    if (url.includes('locations')) {
      shop.hasLocations = true;
    }

    let regex = /#\/teams\/([0-9]+)/g;
    let match = regex.exec(url);

    if (match){
      shop.id = match[1];
    }

    return shop;
  }

  setStaffTabBookingsCount() {

    if (this.isStaff) {
      this.getBookingsCountForStaff().then((count: number) => {
        this.totalStaffBookings = count;
      });
    }
  }

  ionViewWillEnter() {
    this.toggleMyChairTabElement();
  }

  ngOnInit() {
    this.getBookings().then((bookings) => {
      this.updateBookingsCount(bookings);
      //this.loading = false;
    });
  }

  getBookings() {
    return new Promise((resolve, reject) => {
      this.http.get(`/bookings/${this.tuid}`)
        .subscribe((bookings: any) => {
          resolve(bookings);
        }, error => {
          this.errors = this.apiErrorHandler.handleError(error);
          reject(false);
        })
    });
  }

  getBookingsCountForStaff() {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${this.teamId}/staff/${this.tuid}/bookings`)
        .subscribe((bookings: any) => {
          resolve(bookings);
        }, error => {
          this.errors = this.apiErrorHandler.handleError(error);
          reject(false);
        });
    });
  }

  updateBookingsCount(bookings) {
    let total: number = 0;
    for (let booking of bookings) {
      if (booking.completed_at === null && booking.cancelled_at === null) {
        total += 1;
      }
    }

    this.totalUpcomingBookings = total;
  }

  toggleMyChairTabElement() {
    if (!this.tuid) return this.hasMultiShops = false;

    this.http.get(`/staff/${this.tuid}`).subscribe((staff: any) => {
      this.hasMultiShops = staff.teams.length > 1;
    }, error => {
      this.apiErrorHandler.handleError(error);
      this.hasMultiShops = false;
    })
  }
  private async detectShopType(shopId): Promise<void> {
    const shop: any = await this.http.get(`/teams/${shopId}`).toPromise();
    if (shop.settings.shop_type === 0) {
     this.tab1Root = ShopPage;
     this.app.getActiveNav().push(ShopPage);
    }
    if (shop.settings.shop_type === 1) {
     this.tab1Root = CoffeShopPage;
     this.app.getActiveNav().push(CoffeShopPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts